import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";

import { useSelector } from "react-redux";
import moment from "moment";
import { PatientDetailsLabel } from "./Utils";

function PatientDetails({ patientdata }) {
  const [list, setList] = useState({ progressStatus: [] });
  const DashboardStatus = useSelector((state: any) => state.dashboard.status);
  let status = DashboardStatus.map((item) => ({
    label: item.name,
    value: item.name,
    id: item.id,
    icon: item.others,
  }));
  useEffect(() => {
    status &&
      setList({
        progressStatus: status,
      });
  }, []);
  const formattedDateTime = moment(patientdata?.lastContacted).format(
    "DD-MM-YYYY HH:mm:ss"
  );
  let data = { ...patientdata, lastContacted: formattedDateTime };

  return (
    <div className="mb-2">
      <span className="title">Patient Detail</span>
      <Row className="mt-5">
        {PatientDetailsLabel.map((item, index) => {
          return (
            <Col className="mb-5" md={6} key={index}>
              <item.tag {...item} {...data} opt_list={list} disab={true} />
            </Col>
          );
        })}
      
      </Row>
    </div>
  );
}

export default PatientDetails;
